var _ellipse, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaAlertChek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 4.5,
    fill: "white",
    stroke: "#717171"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9.0625C7.875 9.57944 7.45444 10 6.9375 10C6.42056 10 6 9.57944 6 9.0625C6 8.54556 6.42056 8.125 6.9375 8.125C7.45444 8.125 7.875 8.54556 7.875 9.0625ZM6.10852 4.2953L6.26789 7.4828C6.27538 7.63248 6.39892 7.75 6.54879 7.75H7.32621C7.47608 7.75 7.59962 7.63248 7.60711 7.4828L7.76648 4.2953C7.77451 4.13465 7.64644 4 7.48559 4H6.38941C6.22856 4 6.10049 4.13465 6.10852 4.2953Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0115 7.24036L10.0139 6.24278C10.0139 6.24278 10.0139 6.24278 10.0139 6.24277C9.81154 6.0404 9.48342 6.0404 9.28105 6.24278C9.28105 6.24278 9.28105 6.24278 9.28105 6.24278L8.90177 6.62207L8.90177 6.62208C8.69942 6.82445 8.6994 7.15255 8.90177 7.35492L10.6451 9.09821C10.8474 9.3006 11.1755 9.30059 11.3779 9.09824L11.3779 9.09823L14.4622 6.01391L14.4622 6.01391C14.6646 5.81154 14.6646 5.48344 14.4622 5.28107L14.0829 4.90178L14.0829 4.90177C13.8806 4.69941 13.5525 4.69941 13.3501 4.90177L11.0115 7.24036Z",
    fill: "#717171",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaAlertChek);
export default __webpack_public_path__ + "static/media/fa-alert-chek.d7dd42130b1241eb9290d0978eeddf3b.svg";
export { ForwardRef as ReactComponent };